import React from 'react';
import {
    Avatar, Button,
    Div, Input,
    List, ModalPage, ModalPageHeader, ModalRoot, PanelHeaderButton, SplitCol, SplitLayout
} from '@vkontakte/vkui';
import {
    Icon20AddCircleOutline, Icon24BrowserBack, Icon24Cancel, Icon24MinusOutline
} from "@vkontakte/icons";
import {AdaptivityContext, formatQnt, getGUID, values_facing_monitoring_key} from "../assets/constants";
import Fancybox from "../assets/fancybox";
import KBInput from "../assets/KBInput";
import * as constants from "../assets/constants";

import ParamsList from "../catalog/ParamsList";
import IncomingProducts from "../incoming/IncomingProducts";

class FacingMonitoringProducts extends IncomingProducts {

    state = {
        items_values: {},
        currentProduct: {},


    }
    interval = null
    setCurrentValue = (index, val, sendFacingIdsChanged = true, save = true) => {

        clearInterval(this.interval)
        const olds = this.state.items_values
        const old = olds[index] ?? {}
        old.qnt = val
        old.sort = Object.keys(olds).length +1
        olds[index] = old
        this.setState({items_values: olds})


        if (sendFacingIdsChanged) {
            const ids = Object.keys(olds).sort((a, b) => olds[b].sort  - olds[a].sort )

            window.postMessage({type: 'FacingIdsChanged', ids})
        }

        if (save) {
            setTimeout(() => this.saveValues(), 700)
        }

    }
    removeCurrentValue = (index, val) => {

        const olds = this.state.items_values
        if (olds[index]) {
            delete olds[index]
        }
        this.setState({items_values: olds})

        const ids = Object.keys(olds).sort((a, b) => olds[b].sort  - olds[a].sort )

        window.postMessage({type: 'FacingIdsChanged', ids})
    }

    constructor(props) {
        super(props);
        this.GUID = getGUID()

        const data = localStorage.getItem(constants.values_facing_monitoring_key)

        if (data && data !== "undefined") {
            const items = JSON.parse(data)

            this.state.items_values = items
        }
    }

    saveValues = () => {
        localStorage.setItem(constants.values_facing_monitoring_key, JSON.stringify(this.state.items_values ? this.state.items_values : {}))
    }
    loadValues = () => {
        const data = localStorage.getItem(constants.values_facing_monitoring_key)

      //  console.log(data)
        if (data && data !== "undefined") {
            const items = JSON.parse(data)
            this.setState({items_values: items})

            const ids = Object.keys(items).sort((a, b) => items[b].sort - items[a].sort)
            window.postMessage({type: 'FacingIdsChanged', ids})
        }
    }


    componentDidUpdate(prevProps: Readonly<P>, prevState: Readonly<S>, snapshot: SS) {
        if (prevProps.search !== this.props.search) {

        }
    }

    componentDidMount() {
        super.componentDidMount();
        this.loadValues()

    }

    componentWillUnmount = () => {
        super.componentWillUnmount()
        this.saveValues()
    }


    receiveMessage = (event) => {
        if (event.data == 'FacingMonitoringGoGetBack') {
            if (this.state.activeModal == null) {
                window.postMessage("stepPrev")
            } else {
                this.modalBack()
            }
        }
        if (event.data.type == 'IncrementFacingMonitoringValue' && event.data.id) {

            const qnt = this.state.items_values ? (this.state.items_values[event.data.id]?.qnt ?? '') : ''

            this.setCurrentValue(event.data.id, qnt == '' ? 1 : qnt + 1, false)
        }

        if (event.data.type == 'IncrementFacingMonitoringValues' && event.data.items) {
            const olds = this.state.items_values



            event.data.items.map((item, index) => {


                const old = olds[item.id] ?? {}
                const qnt = old.qnt ?? ''
                old.qnt = qnt * 1 + 1
                old.sort = Object.keys(olds).length +1
                olds[item.id] = old
                if (index == 0) {

                }

                if (index == event.data.items.length - 1) {
                    window.postMessage({type: 'last_monitoring_product_name', productName: item.name})
                    const ids = Object.keys(olds).sort((a, b) => olds[a].sort- olds[b].sort)

                    window.postMessage({type: 'FacingIdsChanged', ids})
                    this.setState({items_values: olds,})
                    setTimeout(() => this.saveValues(), 700)
                }


            })
        }
    }

    render() {
        const images_url = this.props.base_url.replace("frontend/", '');

        const modals = (
            <ModalRoot activeModal={this.state.activeModal}>
                <ModalPage
                    id={constants.MODAL_PARAMS_LIST}
                    hideCloseButton={AdaptivityContext.isMobile}
                    onClose={this.modalBack}
                    settlingHeight={100}

                    header={
                        <ModalPageHeader className="sclads"
                                         before={<PanelHeaderButton
                                             onClick={this.modalBack}><Icon24BrowserBack/></PanelHeaderButton>}

                        >
                            Свойства товара {this.state.currentProduct.name}
                        </ModalPageHeader>
                    }
                >
                    <ParamsList
                        base_url={this.props.base_url}
                        product={this.state.currentProduct}
                        current_user={this.props.current_user}
                    />
                </ModalPage>

            </ModalRoot>
        );
        let number = 0
        return (
            <SplitLayout modal={modals}>
                <SplitCol>
                    <List className="incoming-products-list" style={{marginBottom: '70px'}}>
                        <Fancybox key={'IncomingProductsFancyBox' + this.GUID}>
                            {this.props.items.map((item, index) => {

                                const qnt = this.state.items_values ? (this.state.items_values[item.id]?.qnt ?? '') : ''
                                if(qnt > 0 || qnt !== ''){
                                    number++
                                }

                                const words = this.props.search.toLowerCase().split(' ')

                                    let find = true

                                    if (!this.props.search.endsWith('$')) {
                                        words.map(word => {
                                            if (item.name.toLowerCase().indexOf(word) === -1) find = false
                                        })
                                    }
                                    if (!find) return


                                    return (
                                        <Div className={"incoming-products-row "}

                                             key={"incomingProductRow" + this.GUID + index}>
                                            <div className="incoming-products-row_number">
                                                <span>{qnt > 0 || qnt !== ''? number: ''}</span>

                                            </div>
                                            <div className="incoming-products-row_name"
                                                 onClick={() => this.setCurrentValue(item.id, qnt == '' ? 1 : qnt)}>
                                                <span>{item.name}</span>

                                            </div>
                                            <div
                                                className="incoming-products-row_qnt-need">
                                                <Button mode="secondary" size="s" disabled={qnt == '' || qnt == 0}
                                                        onClick={() => this.setCurrentValue(item.id, qnt == '' ? 1 : qnt - 1)}

                                                        className="btn-toolbar-sclads incoming-products-row_btn-info"
                                                ><Icon24MinusOutline width={18}/></Button>
                                            </div>
                                            {!this.props.hideInput &&
                                                <div className="incoming-products-row_qnt">
                                                    <KBInput value={qnt ?? ''}
                                                             onChange={(val) => this.setCurrentValue(item.id, val)}
                                                             readonly={this.props.readonly}/>

                                                </div>}
                                            <div
                                                className="incoming-products-row_qnt-need"
                                                style={{marginLeft: '-11px', width: '8%'}}>
                                                <Button mode="secondary" size="s"
                                                        onClick={() => this.setCurrentValue(item.id, qnt == '' ? 1 : qnt + 1)}

                                                        className="btn-toolbar-sclads incoming-products-row_btn-info"
                                                ><Icon20AddCircleOutline width={18}/></Button>
                                            </div>
                                            <a data-fancybox={'gallery' + item.GUID}
                                               href={images_url + item.mainImage.replace('https:/l', 'https://l').replace('https:/lab', 'https://lab').replace(images_url, '')}>
                                                {<Avatar mode="image" style={{borderRadius: '5%'}}
                                                         size={AdaptivityContext.isMobile ? 40 : 140}
                                                         src={images_url + 'image/200/200/' + item.mainImage.replace('https:/l', 'https://l').replace('https:/lab', 'https://lab').replace(images_url, '')}
                                                />}
                                            </a>

                                            <div className="incoming-products-row_btns">
                                                <Button mode="secondary" size="s" onClick={() => this.removeProduct(index)}

                                                        className="btn-toolbar-sclads incoming-products-row_btn-info"
                                                ><Icon24Cancel width={18}/></Button>
                                            </div>
                                        </Div>)
                                }
                            )}
                        </Fancybox>
                    </List>
                </SplitCol>
            </SplitLayout>
        )
    }

    removeProduct = (index) => {
        const olds = this.props.items
        const old = olds[index]
        if (old) {
            this.removeCurrentValue(old.id)
        }
        this.setState({items: olds.splice(index, 1)})
    }
}

export default FacingMonitoringProducts